import api, { requestsApi } from './api';

export const getSignedUpClients = async () => await api.get('impact/csr/users');

export const getOrganizations = async () => await api.get('shops');

export const getRepresentatives = async () => await requestsApi.get('profile/representatives');
